import { useQuery } from "@apollo/client";
import { Box, Card, Container, Group, Text } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import { USERS } from "apollo/queries";
import { useEffect, useState } from "react";
import { formatNumber } from "utiles/url";

const UserStatus = () => {
  const [result, setData] = useState();
  const roles = JSON.parse(localStorage.getItem("roles")) || [];

  const hasSupplierPermission = roles.some(
    (permission) => permission === "supplier",
  );

  const { data, loading, refetch } = useQuery(USERS, {
    skip: hasSupplierPermission,
    onError(error) {
      showNotification({
        color: "red",
        title: "Error",
        message: error?.graphQLErrors?.[0]?.message || "Failed to get users",
      });
    },
  });

  useEffect(() => {}, []);

  const datas = [
    {
      title: "Suppliers",
      value: data?.getUserStatusDashboard?.total_suppliers || 0,
      icon: "🏭",
    },
    {
      title: "SME Suppliers",
      value: data?.getUserStatusDashboard?.total_sme_suppliers || 0,
      icon: "🏭",
    },
    {
      title: "Retailers",
      value: data?.getUserStatusDashboard?.total_retailers || 0,
      icon: "🛒",
    },
    {
      title: "Drivers",
      value: data?.getUserStatusDashboard?.total_drivers || 0,
      icon: "🚚",
    },
  ];

  return (
    <Container>
      <Card shadow="sm" radius="md" padding="lg" style={{ marginTop: "20px" }}>
        <Group
          spacing="md"
          position="apart"
          noWrap
          style={{
            overflowX: "auto",
            whiteSpace: "nowrap",
          }}
        >
          {datas.map((item, index) => (
            <Box
              key={index}
              style={{
                display: "inline-flex",
                alignItems: "center",
                // backgroundColor: "#f8f9fa",
                padding: "10px 15px",
                borderRadius: "8px",
                flex: "0 0 auto",
                maxWidth: "150px",
              }}
            >
              <div
                style={{
                  marginRight: "16px",
                  fontSize: "23px",
                }}
              >
                {item.icon}
              </div>
              <div>
                <Text
                  style={{ fontWeight: 700, color: "#101F0C" }}
                  size="xs"
                  color="dimmed"
                >
                  {item.title}
                </Text>
                <Text
                  style={{
                    color: "#F36825",
                    fontWeight: 700,
                  }}
                  size="lg"
                  weight={700}
                >
                  {formatNumber(item.value)}
                </Text>
              </div>
            </Box>
          ))}
        </Group>
      </Card>
    </Container>
  );
};

export default UserStatus;
